'use client'

import React from 'react'

import { BaseGrid, BaseGridLayoutProps } from './styles'

export interface GridProps extends BaseGridLayoutProps {
  /**
   * Class name
   */
  className?: string

  /**
   * HTML tag
   */
  as?: keyof HTMLElementTagNameMap

  /**
   * Children
   */
  children?: React.ReactNode
}

/**
 * Grid layout component
 */
export const Grid = ({ children, ...rest }: GridProps) => {
  return <BaseGrid {...rest}>{children}</BaseGrid>
}
